import api from "../utils/api";

export const fetchListings = async (filters = {}) => {
  try {
    const { data } = await api.get("/listings", { params: filters });
    return data;
  } catch (error) {
    console.error("Error fetching listings:", error);
    throw error;
  }
};

export const fetchListingById = async (id) => {
  try {
    const { data } = await api.get(`/listings/${id}`);
    return data;
  } catch (error) {
    console.error(`Error fetching listing ${id}:`, error);
    throw error;
  }
};

export const fetchPropertyValuation = async (address, city, state) => {
  try {
    const { data } = await api.get("/property/valuation", {
      params: { address, city, state },
    });
    return data;
  } catch (error) {
    console.error(`Error fetching property valuation for ${address}:`, error);
    throw error;
  }
};

export const fetchPropertyDetails = async (id) => {
  try {
    const { data } = await api.get(`/property/${id}`);
    return data;
  } catch (error) {
    console.error(`Error fetching property details for ${id}:`, error);
    throw error;
  }
};

export const fetchStates = async () => {
  try {
    const { data } = await api.get("/states");
    return data;
  } catch (error) {
    console.error("Error fetching states:", error);
    throw error;
  }
};

export const fetchCountiesByState = async (state) => {
  try {
    const { data } = await api.get(`/counties/${state}`);
    return data;
  } catch (error) {
    console.error(`Error fetching counties for state ${state}:`, error);
    throw error;
  }
};

export const fetchCitiesByCounty = async (county) => {
  try {
    const { data } = await api.get(`/cities/${county}`);
    return data;
  } catch (error) {
    console.error(`Error fetching cities for county ${county}:`, error);
    throw error;
  }
};

export const triggerScrape = async () => {
  try {
    const { data } = await api.post("/scrape");
    return data;
  } catch (error) {
    console.error("Error triggering scrape:", error);
    throw error;
  }
};

export const fetchPropertyAnalysis = async (property) => {
  try {
    // Extract profit percentage if available
    let profitValue = null;
    if (property.profit !== undefined) {
      profitValue = property.profit;
    } else if (property.profitFormatted) {
      // Try to parse from formatted string like "+15.2%"
      const match = property.profitFormatted.match(/([+-]?\d+\.?\d*)/);
      if (match) {
        profitValue = parseFloat(match[1]);
      }
    }

    // Prepare complete property data for analysis
    const propertyData = {
      address: property.address,
      city: property.city,
      state: property.state,
      county: property.county,
      upsetValue: property.upset_value_numeric,
      defendant: property.defendant,
      courtCaseNo: property.court_case_no,
      saleDate: property.sale_date,
      zillow_estimate: property.marketValue || property.zillow_estimate,
      profit: profitValue,
      property_type: property.property_type,
      description: property.description,
      status: property.status,

      // Include all Zillow property details
      bedrooms: property.bedrooms,
      bathrooms: property.bathrooms,
      livingArea: property.livingArea,
      yearBuilt: property.yearBuilt,
      lotSize: property.lotSize,
      homeType: property.homeType,
      rentZestimate: property.rentZestimate,
      valueHistory: property.valueHistory,
      agent: property.agent,
      dataSource: property.dataSource,
    };

    const { data } = await api.post("/property-analysis", propertyData);

    // Return the analysis data along with the exact source information
    return {
      ...data.analysis,
      // Preserve the exact source information from the server
      analysisEngine: data.analysisEngine,
      // Include any additional notes or simulation reason
      note: data.simulationReason
        ? `Simulation: ${data.simulationReason}`
        : data.note,
      // Add API error information if available
      apiError: data.apiError,
    };
  } catch (error) {
    console.error("Error fetching property analysis:", error);
    throw error;
  }
};

export const fetchResidentDetails = async (address) => {
  try {
    const { data } = await api.post("/resident-details", { address });
    return data;
  } catch (error) {
    console.error(`Error fetching resident details for ${address}:`, error);
    throw error;
  }
};

export default api;
